/**
 * @generated SignedSource<<460ffaf13eb3534e1170e7528e27456e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type genericArticleFooterArticle$data = {
  readonly entityId: string;
  readonly " $fragmentType": "genericArticleFooterArticle";
};
export type genericArticleFooterArticle$key = {
  readonly " $data"?: genericArticleFooterArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"genericArticleFooterArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "genericArticleFooterArticle",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "c94b36f03bb93d290fa95622cb897dfe";

export default node;
